<user-navigation></user-navigation>

<div id="top"></div>

<div id="exerciseConfirmation">
  <section class="h-100">
    <header class="container h-100">
      <div class="d-flex align-items-center justify-content-center h-100">
        <div class="confirmation-body">
          <h4 class="text-center">Continue to Breathing Exercise</h4>
          <p class="text-center mt-3 mt-md-3 mb-5 mb-md-5">Would you like to continue to the 60 second breathing<br>exercise or go back to the homepage?</p>

          <div class="row">
            <div class="col-md-12 d-flex justify-content-center align-items-center">
              <button class="btn btn-primary btn-homepage mr-3 mr-md-3" [routerLink]="['/user/dashboard']">Homepage</button>
              <button
                class="btn btn-primary btn-exercise"
                [routerLink]="['/user/breathing-exerise/', seriesId, moduleId]"
                [queryParams]="{exercise_active: true}"
              >
                Breath Exercise
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  </section>
</div>

<div class="container-fluid">
  <div class="row no-gutter">
    <div class="col-xl-3 d-none d-sm-none d-md-none d-lg-none d-xl-block">
      <series-navigation></series-navigation>
    </div>
    <div class="col-md-12 col-lg-12 col-xl-9" *ngIf="question">
      <div class="exercise">
        <div class="white-box mx-2 mx-md-5 mx-lg-5">
          <h2 class="title font-weight-bold" [innerHTML]="question.question"></h2><br>
          <div id="questions" class="mt-4 mt-md-4">
            <ul>
              <li *ngFor="let answer of question?.answers; let answerIndex = index">
                <label class="checkbox-container">
                  <span [innerHTML]="answer.text"></span>
                  <input type="radio" name="answer" [id]="'answer_' + answerIndex" (click)="getAnswers(answer.is_right, question, answerIndex)">
                  <span
                    class="checkmark"
                    [ngClass]="{'wrong': answer.is_right == 0, 'right': answer.is_right == 1}"
                  >
                  </span>
                </label>
              </li>
            </ul>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="float-sm-right float-md-right float-lg-right">
                <button
                  class="btn btn-primary mt-5 mt-md-5 mb-3 mb-md-3 previous"
                  *ngIf="!hidePreviousButton"
                  (click)="goToPreviousQuestion()"
                >
                  Previous Question
                </button>
                <button
                  [disabled]="disabledButton"
                  (click)="getNextPage()"
                  class="btn btn-primary mt-md-5 mb-3 mb-md-3 mr-3 mr-md-3 submit"
                >
                  <a>{{ buttonLabel }}</a>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Modal Loader -->
  <modal-loader [modalText]="modalText"></modal-loader>

</div>
